import React from 'react'

interface GiftBoxIconProps {
  size?: number
}

const GiftBoxIcon: React.FC<GiftBoxIconProps> = ({ size = 30 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="fi_4007835" clipPath="url(#clip0_32057_79868)">
        <path
          id="Vector"
          d="M3.00938 17.8132H14.0063V29.7945H5.68125C4.79847 29.792 3.95241 29.4409 3.32731 28.8176C2.7022 28.1942 2.34869 27.3491 2.34375 26.4664V17.757C2.55938 17.8132 2.8125 17.8132 3.00938 17.8132ZM16.0031 17.8132V29.7945H24.375C25.2569 29.792 26.102 29.4406 26.7256 28.817C27.3492 28.1934 27.7007 27.3483 27.7031 26.4664V17.757C27.4815 17.7709 27.2592 17.7709 27.0375 17.757L16.0031 17.8132ZM30 9.80699V12.7976C29.9976 13.5918 29.6823 14.353 29.1225 14.9163C28.5627 15.4796 27.8035 15.7996 27.0094 15.807H3.00938C2.212 15.8045 1.44799 15.4867 0.884157 14.9228C0.320325 14.359 0.0024725 13.595 0 12.7976L0 9.80699C0.00491737 9.01286 0.322567 8.25265 0.884114 7.69111C1.44566 7.12956 2.20587 6.81191 3 6.80699H3.10313C2.56327 6.09202 2.29721 5.2074 2.35313 4.31324C2.49419 3.14112 3.05343 2.05926 3.92813 1.26637C4.60329 0.600612 5.51121 0.223994 6.45938 0.216369C7.00306 0.204879 7.54486 0.284089 8.0625 0.450744C9.45235 0.994934 10.7252 1.80003 11.8125 2.82262C12.9795 3.839 14.0583 4.95235 15.0375 6.15074C16.0189 4.94537 17.1043 3.82858 18.2813 2.81324C19.3691 1.79139 20.6418 0.986384 22.0313 0.441369C22.7263 0.178068 23.4813 0.114919 24.2104 0.259092C24.9396 0.403264 25.6137 0.748982 26.1563 1.25699C27.0326 2.03933 27.5983 3.11082 27.75 4.27574C27.8018 5.16941 27.5362 6.05265 27 6.76949C27.3968 6.77071 27.7894 6.85039 28.1553 7.00393C28.5212 7.15747 28.8531 7.38186 29.1319 7.66416C29.4107 7.94647 29.631 8.28113 29.7799 8.64888C29.9289 9.01664 30.0037 9.41022 30 9.80699ZM12.9938 6.80699C12.2305 5.92875 11.4099 5.10194 10.5375 4.33199C9.63009 3.4919 8.57899 2.82186 7.43438 2.35387C7.06298 2.20395 6.66167 2.14295 6.2625 2.17574C5.90118 2.23195 5.57017 2.41069 5.325 2.68199C4.79265 3.12697 4.4396 3.7498 4.33125 4.43512C4.30405 4.8618 4.43042 5.28413 4.6875 5.62574C5.06593 6.10873 5.53783 6.51048 6.075 6.80699H12.9938ZM25.8 4.43512C25.6876 3.74904 25.3314 3.12655 24.7969 2.68199C24.5503 2.41248 24.22 2.2341 23.8594 2.17574C23.4604 2.14695 23.0599 2.20781 22.6875 2.35387C21.5452 2.82084 20.497 3.49105 19.5938 4.33199C18.7191 5.09955 17.8984 5.92651 17.1375 6.80699H24.0563C24.5833 6.5074 25.0454 6.10584 25.4156 5.62574C25.6763 5.28458 25.812 4.8643 25.8 4.43512Z"
          fill="url(#paint0_linear_32057_79868)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_32057_79868"
          x1="15"
          y1="30.001"
          x2="15"
          y2="0.000975733"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3294EF" />
          <stop offset="0.773175" stopColor="#73B5F2" />
          <stop offset="0.773275" stopColor="#B8D6F7" />
          <stop offset="1" stopColor="#C2D9F6" />
        </linearGradient>
        <clipPath id="clip0_32057_79868">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GiftBoxIcon
